import { render, staticRenderFns } from "./ReviewForm.vue?vue&type=template&id=3568094d&scoped=true&"
import script from "./ReviewForm.vue?vue&type=script&lang=js&"
export * from "./ReviewForm.vue?vue&type=script&lang=js&"
import style0 from "./ReviewForm.vue?vue&type=style&index=0&id=3568094d&lang=scss&scoped=true&"
import style1 from "./ReviewForm.vue?vue&type=style&index=1&id=3568094d&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3568094d",
  null
  
)

export default component.exports